import { FC } from 'react';
import { Alert } from './AlertInvalidationRequested.style';

const AlertInsufficientFunds: FC = () => {
    return <Alert message="Insufficient funds to approve the declaration." type="warning" showIcon />;
};
export default AlertInsufficientFunds;
